import { NAME } from './constants';

export const SET_CONTENT_USAGE_PERIOD = `${NAME}.SET_CONTENT_USAGE_PERIOD`;
export const SET_CATEGORY_FOR_SUBCATEGORIES = `${NAME}.SET_CATEGORY_FOR_SUBCATEGORIES`;
